import React, { useState } from 'react';
import Meta from "../../components/Meta";
import SecondDescripton from "../../components/common/SecondDescripton";
import WhoIsThisFor from "../../components/our-world-of-impact/WhoIsThisFor";
import Image from "next/image";
import common_data from "../../data/common_data";
import Link from "next/link";




// Main App Component
const App = () => {
  const outcomes = [{
    list: [{
      icon: <SpeechBubbleIcon />,
      text: "A new way to explain what you do and why it matters",
    },
    {
      icon: <HeartIcon />,
      text: "Greater emotional connection to your mission",
    },
    {
      icon: <NetworkIcon />,
      text: "Expanded reach",
    },]
  }, {
    list: [{
      icon: <CheckCircleIcon />,
      text: "Deep, sustained engagement",
    },
    {
      icon: <CertificateIcon />,
      text: "Verified learning and participation outcomes",
    },
    {
      icon: <StorybookIcon />,
      text: "Scalable storytelling tools and creative campaigns",
    },]
  },
  ];
  const features = [
    {
      icon: <GlobeTargetIcon />,
      title: "Designed for Real-World Impact",
      description:
        "Each game links to something in the real world, guiding players toward meaningful action and understanding.",
    },
    {
      icon: <GearsIcon />,
      title: "Built With Purpose",
      description:
        "Developed through interdisciplinary collaboration, blending insights from multiple fields for accessibility and engagement.",
    },
    {
      icon: <HeartsIcon />,
      title: "Connected to Causes",
      description: "Games directly support real campaigns and social missions.",
    },
    {
      icon: <AIIcon />,
      title: "Includes Ethical AI",
      description:
        "For curated learning and contributions without compromising values or privacy.",
    },
    {
      icon: <TrophyIcon />,
      title: "Measurable, Shareable, Meaningful",
      description:
        "Player achievements are verified, visible, and valued, all mapped through digital ImpactDots.",
    },
  ];
  const steps = [
    {
      number: "1",
      title: "Create or Use a Game",
      description: "Reflects your issue, innovation, or mission.",
      icon: <GameControllerIcon />,
    },
    {
      number: "2",
      title: "Integrate Impact Art",
      description: "Visual content tied to your campaign or cause.",
      icon: <PaletteIcon />,
    },
    {
      number: "3",
      title: "Engage Players",
      description: "To act, donate, unlock, and share.",
      icon: <UsersIcon />,
    },
    {
      number: "4",
      title: "Increase Funding & Impact",
      description: "Greater funding, engagement and real impact.",
      icon: <MoneyBagIcon />,
    },
  ];
  return (
    <>
      <Meta title="Our World Of Impact || Impactoverse" />

      <section className="relative pt-[9rem] lg:pb-24 text-center">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
          <Image
            width={1519}
            height={773}
            priority
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <div className="lg:flex lg:space-x-12">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={935}
              src="/images/gradient.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
            <Image
              width={1519}
              height={935}
              src="/images/gradient_dark.jpg"
              alt="gradient dark"
              className="h-full w-full object-cover"
            />
          </picture>
        </div>
        <div className="container mx-auto text-center">
          <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
            OUR WORLD OF
            <span className="animate-gradient"> IMPACT</span>
            <br />
          </h1>
          <h3 className="font-display max-sm:my-5 text-2xl text-jacarta-700 dark:text-white lg:text-2xl xl:text-3xl text-center uppercase">
            Play With Purpose. <br />Learn, Act, and Drive Real-World Change.
          </h3>
          <SecondDescripton text={`Impactoverse’s gaming ecosystem transforms learning, awareness, and social action into engaging experiences. These aren’t just games, they’re gateways to understanding global challenges, increasing awareness and gaining new skills, building communities and contributing to real-world solutions. Whether you’re here to learn, co-create, fundraise, or amplify your mission, this is where impact becomes interactive.`} ></SecondDescripton>
          {/* <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
                          <button className=" mx-auto mt-8 px-8 py-4 bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all">
                 Start Your Impact Journey
              </button>
        
          </div> */}

        </div>
      </section>
      <section className="py-12 px-6 max-w-6xl mx-auto">
        <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-8">
          What Makes <span className="animate-gradient"> This Different?</span>
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {features.map((feature, index) => (
            <div
              key={index}
              className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg"
            >
              <div className="flex items-center justify-center">
                <div
                  className={`rounded-full w-20 h-20 m-4 flex items-center justify-center bg-accent-dark color-white`}
                >
                  {feature.icon}
                </div>
              </div>
              <h3 className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white uppercase">
                {feature.title}
              </h3>
              <p className="text-lg dark:text-jacarta-300">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Who Is This For? Section (Accordion) */}
      <WhoIsThisFor />


      {/* Fundraise Through Gameplay Section */}
      <section className="py-12 px-6 max-w-6xl mx-auto">
        <div className='mb-8'>

          <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase ">
            FUNDRAISE <span className="animate-gradient"> THROUGH GAMEPLAY</span>
          </h1>
          <SecondDescripton lg={15} text={`Gamified experiences can do more than teach, they can raise real funds for real change. Through integrated impact art campaigns, users can unlock collectibles, donate directly through gameplay, or support campaigns as they interact with stories and challenges.`} ></SecondDescripton>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {steps.map((feature, index) => (
            <div
              key={index}
              className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg"
            >
              <div className="flex items-center justify-center">
                <div
                  className={`rounded-full w-20 h-20 m-4 flex items-center justify-center bg-accent-dark color-white`}
                >
                  {feature.icon}
                </div>
              </div>
              <h3 className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white uppercase">
                {feature.title}
              </h3>
              <p className="text-lg dark:text-jacarta-300">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </section>
      {/* What to Expect Section */}
      <section className="py-16 px-10 bg-gray-100 dark:bg-jacarta-900">
        <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-8">
          WHAT TO <span className="animate-gradient"> EXPECT</span>
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">
          {outcomes.map((persona, index) => (
            <div
              key={index}
              className="bg-white dark:bg-jacarta-700 border border-jacarta-100 dark:border-jacarta-600 rounded-3xl p-8 text-center shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col"
            >

              <ul className="text-left text-jacarta-500 dark:text-jacarta-300 space-y-3 mb-8 text-base">

                {persona.list && persona.list.map((x, i) => (<li key={i} className="flex items-start gap-2">
                  <span className=" text-accent">
                    {x.icon}
                  </span>
                  <span className='text-lg dark:text-jacarta-300'>{x.text}</span>
                </li>)
                )
                }
              </ul>
            </div>
          ))}
        </div>
      </section>



        {/* Ready to Activate & Call to Action Section */}

    <section className="pb-0">
  <div className="container">
    <div className="rounded-2.5xl bg-light-base px-10 py-10 text-center dark:bg-jacarta-700">
      <div>
        <h2 className="mb-5 font-extrabold text-3xl sm:text-4xl md:text-5xl leading-tight drop-shadow-md">
          Ready to Activate?
        </h2>
      </div>
      <div className="m-auto">
        <ul className="text-lg sm:text-xl mb-10 space-y-4 text-start dark:text-jacarta-300">
          {[
            "Customise a space",
            "Co-create a new experience",
            "Embed your brand, tools, or content",
            "Launch a fundraiser or art drop inside a game",
          ].map((text, index) => (
            <li key={index} className="grid grid-cols-[auto_1fr] gap-3 items-start">
              <span className="text-accent mt-1">
                <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                </svg>
              </span>
              <span>{text}</span>
            </li>
          ))}
        </ul>
      </div>

      <Link
        href="/contact-us"
        target="_blank"
        className="inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark uppercase"
      >
        Request a Demo or Exploratory Call
      </Link>

      {/* Optional paragraph block
      <p className="mt-8 text-lg opacity-80 max-w-2xl mx-auto">
        Art isn’t just symbolic, it’s functional. Every contribution, sale, share, and story moves a cause forward.
      </p>
      */}
    </div>
    <div className="mb-20"></div>
  </div>
</section>



    </>
  );
};


// --- Placeholder Icons (Replace with Lucide React or similar for production) ---

const GlobeTargetIcon = () => (
  <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 12V6m0 6a2 2 0 100 4m0-4a2 2 0 110-4m-9 8a2 2 0 100 4m0-4a2 2 0 110-4m9 8a2 2 0 100 4m0-4a2 2 0 110-4"></path>
  </svg>
);

const GearsIcon = () => (
  <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37a1.724 1.724 0 002.572-1.065z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
  </svg>
);

const HeartsIcon = () => (
  <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 22l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
  </svg>
);

const AIIcon = () => (
  <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 12h2m10 0h2M3 12a9 9 0 1118 0 9 9 0 01-18 0z"></path>
  </svg>
);

const TrophyIcon = () => (
  <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11l-3-3m0 0L9 11m3-3V3m0 16a2 2 0 11-4 0 2 2 0 014 0z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 17a2 2 0 114 0 2 2 0 01-4 0zM20 17a2 2 0 11-4 0 2 2 0 014 0zM18 10h1a2 2 0 012 2v3a2 2 0 01-2 2h-1M6 10H5a2 2 0 00-2 2v3a2 2 0 002 2h1"></path>
  </svg>
);

const GraduationCapIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14c-4.418 0-8-2.686-8-6s3.582-6 8-6 8 2.686 8 6-3.582 6-8 6z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14v6m-4-2h8"></path>
  </svg>
);

const MegaphoneIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5.882V19.882a2 2 0 01-2 2H5a2 2 0 01-2-2V5.882a2 2 0 012-2h4a2 2 0 012 2z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 6.118L21 9v6l-4 2.882"></path>
  </svg>
);

const LightbulbGearsIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3L11.725 6m0 0a.75.75 0 001.05 0L15 3m-3 18v-2m-4-2H8m8 0h-1m-1.5-6a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 17a5 5 0 00-10 0v1a2 2 0 002 2h6a2 2 0 002-2v-1z"></path>
  </svg>
);

const FamilyIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4a4 4 0 100 8 4 4 0 000-8z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 20v-2a4 4 0 00-4-4H9a4 4 0 00-4 4v2"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10a2 2 0 100 4 2 2 0 000-4zM19 10a2 2 0 100 4 2 2 0 000-4z"></path>
  </svg>
);

const PaletteIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M12 16l3-3m2 2l4-4"></path>
  </svg>
);

const GameControllerIcon = () => (
  <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 8v8m-4-4h4m-4 0v4m0-4H8m0 0V8m8 0a2 2 0 11-4 0 2 2 0 014 0z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10z"></path>
  </svg>
);

const UsersIcon = () => (
  <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h2a2 2 0 002-2V8a2 2 0 00-2-2h-2a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 6a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2h2a2 2 0 002-2V6z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 10h4m-4 0v4m4-4H7"></path>
  </svg>
);

const MoneyBagIcon = () => (
  <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z"></path>
  </svg>
);

const SpeechBubbleIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
  </svg>
);

const HeartIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 22l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
  </svg>
);

const NetworkIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
  </svg>
);

const CheckCircleIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
  </svg>
);

const CertificateIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14c-4.418 0-8-2.686-8-6s3.582-6 8-6 8 2.686 8 6-3.582 6-8 6z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14v6m-4-2h8"></path>
  </svg>
);

const StorybookIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5 3.013 5 0 8.243 0 12.253c0 3.791 3.197 6.702 7.5 6.702 1.746 0 3.332-.477 4.5-1.253m0-13C13.168 5.477 14.754 5 16.5 5c4.487 0 7.5 3.243 7.5 7.253 0 3.791-3.197 6.702-7.5 6.702-1.746 0-3.332-.477-4.5-1.253"></path>
  </svg>
);


export default App;
